const config = {};

config.baseUrl = "https://hengam-api.gandom.co";
config.serverUrl = config.baseUrl + "/api/v1/";

config.rules = {
  MORNING_START: 5.49, // IN HOUR
  MORNING_END: 9.51,
  MORNING_EXPECT: 1.49,
  NOON: 12.01,
  DAY_EXPECT: 5.99,
  INTENSE_COLORS: ['#0084DB', "#A0E418"],  // intense colors used in barchart when colum duration is above day expect 
  ORDINARY_COLORS: ["#99C0DB", "#CCE29E"]  // ordinary colors used in barchart, second one is used when column contains enough morning records
}

export default config;
